import { CAR_DEFAULT_IMG } from '@components/MainWidget/common/widgetImagesConstant'
import { getChallanData } from '@services/challanServices'
import { proposalService } from '@services/proposalService'
import logger from '@utils/logger'
import { FlagConditionKey, FLAG_OVERRIDES, DEFAULT_LAYOUT_FLAGS, LayoutFlags, messageConfig } from './constants'

export const getVehicleVariantImage = (vehicleImage: any) =>
  vehicleImage?.image || vehicleImage?.logo_url || CAR_DEFAULT_IMG

const vehicleTypeMap = {
  PRIVATE_CAR: 'Car',
  TWO_WHEELER: 'Bike',
}

export const vehicleType = vehicleData => vehicleTypeMap?.[vehicleData?.vehicle_type_v2]

export const getDaysUntilPolicyExpires = (previousPolicyExpiryDetail: string) => {
  const rawTimestamp = Number(previousPolicyExpiryDetail)
  const expiryDate = new Date(rawTimestamp)
  const currentDate = new Date()

  expiryDate.setHours(0, 0, 0, 0)
  currentDate.setHours(0, 0, 0, 0)

  const differenceInTime = expiryDate.getTime() - currentDate.getTime()
  const differenceInDays = Math.floor(differenceInTime / (1000 * 60 * 60 * 24))

  return differenceInDays
}

export const redirectToAutoPayment = async (path: string, regNo: string, phone: string) => {
  try {
    const response = await fetch(`${path}?registration_number=${regNo}&phone=${phone}`)

    if (!response.ok) {
      throw new Error('Failed to fetch redirect URL')
    }

    const data = await response.json()
    const redirectUrl = data?.redirect_url

    if (redirectUrl) {
      window.location.href = redirectUrl
    } else {
      logger.error('No redirect URL returned from API')
    }
  } catch (error) {
    logger.error('Redirection failed:', error)
  }
}

const getConditionKey = (
  isLoggedIn: boolean | undefined,
  hasProposal: boolean,
  hasChallan: boolean
): FlagConditionKey => {
  if (!isLoggedIn) {
    return hasProposal ? 'UNVERIFIED__PROPOSAL' : 'UNVERIFIED__NO_PROPOSAL'
  }
  if (hasProposal && hasChallan) return 'VERIFIED__PROPOSAL__CHALLAN'
  if (hasProposal && !hasChallan) return 'VERIFIED__PROPOSAL__NO_CHALLAN'
  if (!hasProposal && hasChallan) return 'VERIFIED__NO_PROPOSAL__CHALLAN'
  return 'VERIFIED__NO_PROPOSAL__NO_CHALLAN'
}

export const getLayoutFlags = async (
  isLoggedIn: boolean | undefined,
  regNo: string,
  phoneNumber: string
): Promise<LayoutFlags> => {
  try {
    const proposalPromise = proposalService(regNo, phoneNumber)

    let challanPromise: Promise<any> | null = null
    if (isLoggedIn) {
      challanPromise = getChallanData(regNo)
    }
    const [proposalData, challanData] = await Promise.all([proposalPromise, challanPromise ?? Promise.resolve([])])
    const hasProposal = !!proposalData?.proposal_id
    const hasChallan = !!(challanData?.length > 0)

    const conditionKey = getConditionKey(isLoggedIn, hasProposal, hasChallan)
    return {
      ...DEFAULT_LAYOUT_FLAGS,
      ...FLAG_OVERRIDES[conditionKey],
      proposalData,
      challanData,
    }
  } catch (error) {
    logger.error('Error resolving layout flags:', error)
    return DEFAULT_LAYOUT_FLAGS
  }
}

export const getMessageTemplate = (days: number) => {
  const config = messageConfig.find(c => c.test(days))
  return config ? config.get(days) : { prefix: '', highlight: '-', suffix: '' }
}
